module.exports = __webpack_public_path__ + "media/flags/fm-2a7ec9a4.svg";